import { Stack } from '@mui/system'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { EFAdapterMoment } from './EFDatePickerAdapter'
import { useAppSelector } from '~/app/hooks'
import { isDarkTheme, localeSetting } from '~/redux/features'
import { IEFDatePicker } from './EFDatePicker.model'
import { dateTimePaperPropsStyles } from '.'
import { EFCanlendar } from '../EFIcons'

export function EFDatePicker(props: IEFDatePicker) {
  const { label, ...otherProps } = props
  const isDark = useAppSelector(isDarkTheme)
  const { locale } = useAppSelector(localeSetting)

  return (
    <Stack width={'100%'}>
      <LocalizationProvider
        dateAdapter={EFAdapterMoment}
        adapterLocale={locale?.toLowerCase()}
      >
        <DatePicker
          {...otherProps}
          showDaysOutsideCurrentMonth
          dayOfWeekFormatter={day => day.slice(0, 2)}
          slots={{ openPickerIcon: EFCanlendar }}
          slotProps={{
            popper: {
              ...dateTimePaperPropsStyles,
              sx: {
                '.MuiPaper-root': {
                  background: isDark ? 'var(--dark-chart-bg)' : ''
                },
                '*': {
                  color: isDark ? 'white !important' : 'var(--dark)',
                  borderColor: isDark ? 'var(--border-dark-color) !important' : ''
                }
              }
            },
            textField: {
              size: 'small',
              sx: {
                my: 1.5,
                '& *': { color: isDark ? 'white !important' : '' },
                '& fieldset': {
                  borderColor: isDark ? 'var(--border-dark-color) !important' : '#e0e0e0'
                }
              }
            }
          }}
          label={label}
        />
      </LocalizationProvider>
    </Stack>
  )
}
